import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-customers')({
  beforeLoad: () => getTitleContextSlice('All Customers'),
  staticData: {
    owner: CodeOwner.Frontend,
  },
});
